module.exports = __webpack_public_path__ + "media/src/assets/Images/pdf-icon-vector-d1572fac49eed740564726083f76b051.png";